import { getToken, HEADER_PREFIX } from 'utils/auth'

import { ApiBase } from '@/api/api'
import { handleResponseError } from '@/api/apiHelpers'
import {
  AnswerSignature,
  SaveAnswerSignatureProps,
} from '@/types/answers/answerSignature'
import { hasText } from '@/utils/helpers'
import { uploadInChunks } from '@/utils/uploadFileInChunks'

async function token() {
  const userToken = await getToken()
  return userToken ? `${HEADER_PREFIX} ${userToken}` : 'None'
}

function uploadInChunksWithResponse(props: {
  file: File
  responseId: string
  questionId?: string | number
  inputFieldId?: string
  mode: string
  repeat_section_page_id?: string | null
  repeat_section_original_page_id?: string | null
  repeat_section_order?: number | null
}): Promise<AnswerSignature> {
  return new Promise((resolve, reject) => {
    uploadInChunks({
      ...props,
      endpoint: 'answer_signatures',
      onComplete: resolve,
    }).catch(reject)
  })
}

export async function saveAnswerSignature(
  props: SaveAnswerSignatureProps
): Promise<AnswerSignature> {
  const {
    responseId,
    questionId,
    inputFieldId,
    imageFile,
    text,
    mode,
    repeat_section_page_id,
    repeat_section_original_page_id,
    repeat_section_order,
  } = props
  if (imageFile && imageFile instanceof File) {
    return uploadInChunksWithResponse({
      file: imageFile,
      responseId,
      inputFieldId,
      questionId,
      mode,
      repeat_section_page_id,
      repeat_section_original_page_id,
      repeat_section_order,
    })
  } else {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: await token(),
      },
      body: JSON.stringify({
        input_field: inputFieldId,
        image: imageFile,
        text,
        question: questionId,
        response: responseId,
        mode,
        repeat_section_page_id,
        repeat_section_original_page_id,
        repeat_section_order,
      }),
    }
    const res = await fetch(
      `${ApiBase}/answer_signatures?mode=${mode}`,
      options
    )
    if (res.ok === false) {
      const json = await res?.json?.()
      return (await handleResponseError?.(res, {
        hasImage: hasText(imageFile),
        text,
        question: questionId,
        response: responseId,
        mode,
        input_field: inputFieldId,
        repeat_section_page_id,
        repeat_section_original_page_id,
        json,
        repeat_section_order,
      })) as unknown as AnswerSignature
    }
    return await res.json()
  }
}
